import { render } from "./CurrentEmployee.vue?vue&type=template&id=31647d0e&scoped=true"
import script from "./CurrentEmployee.vue?vue&type=script&lang=js"
export * from "./CurrentEmployee.vue?vue&type=script&lang=js"

import "./CurrentEmployee.vue?vue&type=style&index=0&id=31647d0e&scoped=true&lang=css"

import exportComponent from "/Users/thomas/Desktop/CNT/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31647d0e"]])

export default __exports__